import { render } from "./SideMenuRight.vue?vue&type=template&id=5910b255&scoped=true&ts=true"
import script from "./SideMenuRight.vue?vue&type=script&lang=ts"
export * from "./SideMenuRight.vue?vue&type=script&lang=ts"

import "./SideMenuRight.vue?vue&type=style&index=0&id=5910b255&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5910b255"]])

export default __exports__